// extracted by mini-css-extract-plugin
export default {"section":"what_section__YbTJ9","line":"what_line__AAJuA","heading":"what_heading__Qni1H"};